import React from "react";
import camelToTitle from "../../util/case";

const SelectTW = ({ label, value, onChange, selectCategories }) => {
  return (
    <div>
      <label
        htmlFor="category"
        className="block text-sm font-medium text-gray-700"
      >
        {label}:
      </label>
      <select
        id="category"
        value={value}
        onChange={onChange}
        className="mt-1 p-3 w-full rounded-md border border-gray-300"
      >
        {selectCategories.map((mat) => (
          <option key={mat} value={mat}>
            {camelToTitle(mat)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectTW;
